var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "sidebar-loading" },
          [_c("w-progress-circular", { attrs: { small: "" } })],
          1
        )
      : _vm.documents.length == 0
      ? _c("div", { staticClass: "sidebar-empty" }, [
          _vm._v(_vm._s(_vm.$ct("sidebar.contact-documents.none"))),
        ])
      : _c(
          "div",
          { staticClass: "sidebar-table-wrap" },
          [
            _c(
              "app-custom-table",
              {
                staticClass: "sidebar-table",
                attrs: { cellpadding: "0", cellspacing: "0" },
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm.$ct("sidebar.contact-documents.number"))
                      ),
                    ]),
                    _c("th", [
                      _vm._v(_vm._s(_vm.$ct("sidebar.contact-documents.date"))),
                    ]),
                    _c("th", { staticClass: "amount" }, [
                      _vm._v(
                        _vm._s(_vm.$ct("sidebar.contact-documents.amount"))
                      ),
                    ]),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm.$ct("sidebar.contact-documents.status"))
                      ),
                    ]),
                  ]),
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.documents, function (doc) {
                    return _c(
                      "tr",
                      {
                        key: doc.ID,
                        staticClass: "sidebar-doc-row",
                        on: {
                          click: function ($event) {
                            return _vm.open(doc)
                          },
                        },
                      },
                      [
                        _c("td", { staticClass: "sidebar-doc-link" }, [
                          _vm._v(_vm._s(doc.ComputedFriendlyID)),
                        ]),
                        _c("td", [
                          _vm._v(_vm._s(_vm.printDate(doc.InvoiceDate))),
                        ]),
                        _c("td", { staticClass: "amount" }, [
                          _vm._v(_vm._s(_vm.printAmount(doc))),
                        ]),
                        _c("td", {
                          directives: [
                            {
                              name: "safe-html",
                              rawName: "v-safe-html",
                              value: _vm.printStatus(doc),
                              expression: "printStatus(doc)",
                            },
                          ],
                        }),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }